// Validate the read-only feed before rendering. Never treat a successful HTTP
// response with an unexpected body as an empty, complete subscription list.
function parseUpcomingPage(page, cursor) {
  const id = value => typeof value === 'string' && /^[1-9][0-9]{0,15}$/.test(value);
  if (!page || page.version !== 1 || !Array.isArray(page.items) || page.items.length > 50 ||
      !(page.nextCursor === null || (id(page.nextCursor) && BigInt(page.nextCursor) > BigInt(cursor)))) throw new Error('Invalid page');
  for (const item of page.items) {
    if (!item || ![item.sellerId, item.subscriptionId, item.cycleId, item.jobId].every(id) ||
        !['month', 'year'].includes(item.interval) || item.currency !== 'USD' ||
        !Number.isSafeInteger(item.amountMinor) || item.amountMinor <= 0 ||
        !['email', 'firstName', 'productName'].every(key => typeof item[key] === 'string') ||
        !Number.isFinite(Date.parse(item.dueAt)) || !Number.isFinite(Date.parse(item.verifiedAt))) throw new Error('Invalid renewal');
  }
  return page;
}
function mergeUpcoming(previous, incoming) {
  const rows = new Map(previous.map(row => [`${row.sellerId}:${row.subscriptionId}:${row.cycleId}`, row]));
  for (const row of incoming) rows.set(`${row.sellerId}:${row.subscriptionId}:${row.cycleId}`, row);
  return Array.from(rows.values()).sort((a, b) => Date.parse(a.dueAt) - Date.parse(b.dueAt));
}
module.exports = { parseUpcomingPage, mergeUpcoming };
